import * as Sentry from "@sentry/react";
import { useFetchApi } from "./useFetchApi";
import { PolicySummary } from "shared";

/** @returns An array of policies or undefined if the call failed */
export const usePolicySummaries = () => {
  try {
    return useFetchApi<PolicySummary[]>("policies/summary").data;
  } catch (error) {
    // This is needed due to how npm package fetch-suspense works.
    if (error instanceof Promise) {
      throw error;
    }

    Sentry.captureException(error, {
      contexts: {
        context: {
          message: "Unable to fetch household policies on account settings",
        },
      },
    });

    return undefined;
  }
};
